module.exports = __webpack_public_path__ + "img/interact-stu-answer-success_new.501c3082.png";